import {
  UPDATE_SELECTED_LOCATION,
  TOAST_DISPLAYED,
  UPDATE_PREFILL_MESSAGE,
  UPDATE_OPTIONAL_MESSAGE,
  NOTIFICATION_SENT,
  UPDATE_SELECTED_GANG,
  UPDATE_MESSAGE_LIST,
  UPDATE_CHIPS,
  REMOVE_CHIP,
  FETCH_GANGS_FOR_SMS,
  FETCH_LOCATIONS,
  SEARCH_MESSAGES_DATABASE
} from './types';
import axios from 'axios';
import { ROOT_URL } from '../constants';;
const Materialize = window.Materialize;

/**
* updateSelectedLocation(): update list of employees to only include those at specified location
* @params {String}: location: location of employees to select
**/
export function updateSelectedLocation(loc) {
  return (dispatch) => {
    axios.get(`${ROOT_URL}/fetchEmployeeData`, {
      headers: { authorization: localStorage.getItem('token') },
      params: {
        location:loc
      }
    })
      .then((res) => {
        dispatch(fetchGangs(loc));
        dispatch({ type: UPDATE_SELECTED_LOCATION, payload: {location:loc, employees: res.data }})
      }).catch((e) => Materialize.toast('There was an error fetching employees by location', 4000, 'rounded red'));
  }
}

/**
* updateSelectedDepartment(): update display of employees to account for department
* @params {String}: location: location of employees
* @params {String}: dept: department to get employees from
**/
export function updateSelectedGang(location,gang) {
  return (dispatch) => {
    axios.get(`${ROOT_URL}/fetchEmployeeData`, {
      headers: { authorization: localStorage.getItem('token') },
      params: {
        location:location,
        gang:gang
      }
    })
    .then((res) => {
      dispatch({ type: UPDATE_SELECTED_GANG, payload: {gang: gang, employees: res.data }})
    }).catch((e) => Materialize.toast('There was an error updating the selected gang', 4000, 'rounded red'));
  }
}

/**
* notifyEmployees(): send information to server to send out message
* @params {String}: location: location of employees
* @params {String}: department: department to be notified
* @params {String}: message: message to be sent to employees
**/
export function notifyEmployees(location ,department, message, eid) {
  return (dispatch) => {
    axios.get(`${ROOT_URL}/notifyEmployees`, {
      headers: { authorization: localStorage.getItem('token') },
      params: {
        location: location,
        dept: department,
        message: message,
        eid
      }
    })
      .then((res) => {
        dispatch(getMessages());
        dispatch({ type: NOTIFICATION_SENT, payload: res.data});
      }).catch((e) => Materialize.toast('There was an error notifying employees by SMS or call', 4000, 'rounded red'));
  }
}

/**
* notifySelectedEmployees(): send information to server to send out message
* @params {Object}: employees: list of custom selected employees
* @params {String}: message: message to be sent to employees
**/
export function notifySelectedEmployees(employees, message, eid) {
  return (dispatch) => {
    axios.get(`${ROOT_URL}/notifySelectedEmployees`, {
      headers: { authorization: localStorage.getItem('token') },
      params: {
        employees: employees,
        message: message,
        eid
      }
    })
      .then((res) => {
        dispatch(getMessages());
        dispatch({ type: NOTIFICATION_SENT, payload: res.data});
      }).catch((e) => Materialize.toast('There was an error notifying employees by SMS or call', 4000, 'rounded red'));
  }
}

/**
* getMessages(): get previously sent messages from database
**/
export function getMessages() {
  return (dispatch) => {
    axios.get(`${ROOT_URL}/fetchSMSMessages`, {
      headers: { authorization: localStorage.getItem('token') }
    }).then((res) => {
        dispatch({ type: UPDATE_MESSAGE_LIST, payload: res.data})
      }).catch((e) => Materialize.toast('There was an error fetching sent messages', 4000, 'rounded red'));
  }
}

/**
* fetchGangs(): update list of gangs in gang dropdown when location is selected from location dropdown
* @params {String}: location: location of gangs to fetch
**/
export function fetchGangs(loc) {
  return (dispatch) => {
    axios.get(`${ROOT_URL}/fetchGangsForSMS`, {
      headers: { authorization: localStorage.getItem('token') },
      params: {
        location: loc
      }
    })
      .then((res) => {
        dispatch({ type: FETCH_GANGS_FOR_SMS, payload: res.data.gangs });
      }).catch((e) => Materialize.toast('There was an error fetching gangs', 4000, 'rounded red'));
  }
}

/**
* fetchLocations(): get all locations with employees from db to populate location dropdown
**/
export function fetchLocations() {
  return (dispatch) => {
    axios.get(`${ROOT_URL}/fetchLocations`, {
      headers: { authorization: localStorage.getItem('token') },
    }).then((res) => {
        dispatch({ type: FETCH_LOCATIONS, payload: res.data});
    }).catch((e) => Materialize.toast('There was an error fetching locations', 4000, 'rounded red'));
  }
}

/**
* searchMessagesDatabase(): search for messages in db between specified dates
* @params {String}: start: first date to search for
* @params {String}: last: last date to search for
**/
export function searchMessagesDatabase(start, end) {
  return (dispatch) => {
    axios.get(`${ROOT_URL}/searchMessagesDatabase`, {
      headers: { authorization: localStorage.getItem('token') },
      params: {
        start: start,
        end: end
      }
    })
      .then((res) => {
        dispatch({ type: SEARCH_MESSAGES_DATABASE, payload: res.data});
      }).catch((e) => Materialize.toast('There was an error searching for sent messages', 4000, 'rounded red'));
  }
}

/**
* updatePrefillMessage(): update message selected from list
* @params {String}: message: the message selected
**/
export function updatePrefillMessage(message) {
  return (dispatch) => {
    dispatch({ type: UPDATE_PREFILL_MESSAGE, payload: message});
  }
}

/**
* updateOptionalMessage(): update custom message typed by user
* @params {String}: message: the message typed by the user
**/
export function updateOptionalMessage(message) {
  return (dispatch) => {
    dispatch({ type: UPDATE_OPTIONAL_MESSAGE, payload: message});
  }
}

/**
* updateChips(): add an employee to list of custom employee selection
* @params {String}: firstName: first name of employee to add
* @params {String}: lastName: last name of employee to add
* @params {String}: mobile: mobile phone number of employee to add
* @params {String}: number: landline number of employee to add
* @params {String}: id: id of employee to add
**/
export function updateChips(firstName, lastName,mobile, number,id) {
  return (dispatch) => {
    dispatch({ type: UPDATE_CHIPS, payload: {first: firstName, last:lastName, mobilePhone: mobile, phone: number, id: id}});
  }
}

/**
* removeChip(): update list of selected employees by removing a person
* @params {String}: id: id (not eid) of employee to remove
**/
export function removeChip(id) {
  return (dispatch) => {
    dispatch({ type: REMOVE_CHIP, payload: id});
  }
}

/**
* toastDisplayed(): record that a toast with the success/error message was posted after a message attempt
**/
export function toastDisplayed() {
  return (dispatch) => {
    dispatch({ type: TOAST_DISPLAYED, payload: true});
  }
}






/* END */



// WEBPACK FOOTER //
// ./src/actions/alert_actions.js